import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {CurrentMembership, TeamMembersRepository} from "@/repositories/team-members.repository.ts";

interface MembershipState {
    membership: CurrentMembership | null;
    loading: boolean;
    error: string | null;
}

const initialState: MembershipState = {
    membership: null,
    loading: false,
    error: null,
};

export const fetchMembership = createAsyncThunk(
    "membership/fetch",
    async () => {
        return await TeamMembersRepository.getCurrentMembership();
    }
);

const membershipSlice = createSlice({
    name: "membership",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMembership.pending, (s) => {
                s.loading = true;
                s.error = null;
            })
            .addCase(fetchMembership.fulfilled, (s, a) => {
                s.loading = false;
                s.membership = a.payload;
            })
            .addCase(fetchMembership.rejected, (s, a) => {
                s.loading = false;
                s.error = a.error.message ?? "Failed to load membership";
            });
    },
});

export default membershipSlice.reducer;